import compareAsc from 'date-fns/compareAsc';
import { buildDateFromTime } from 'shared/helpers/DateHelper';
import { mapGetters } from 'vuex';
import { createDevLogger } from '../helpers/utils';
import { getTimezoneDate } from '../../shared/helpers/DateHelper';

const devLogger = createDevLogger("D: availability :: ");

export default {
  computed: {
    ...mapGetters({ 
        webChannelConfig: 'appConfig/getWebChannelConfig', 
        onlineAgents: 'agent/availableAgents' 
    }),
    channelConfig() {
      return this.webChannelConfig;
    },
    replyTime() {
      return this.webChannelConfig.replyTime;
    },
    replyTimeStatus() {
      switch (this.replyTime) {
        case 'in_a_few_minutes':
          return this.$t('REPLY_TIME.IN_A_FEW_MINUTES');
        case 'in_a_few_hours':
          return this.$t('REPLY_TIME.IN_A_FEW_HOURS');
        case 'in_a_day':
          return this.$t('REPLY_TIME.IN_A_DAY');
        default:
          return this.$t('REPLY_TIME.IN_A_FEW_HOURS');
      }
    },
    outOfOfficeMessage() {
      return this.channelConfig.outOfOfficeMessage;
    },
    isInBetweenTheWorkingHours() {
      const {
        openHour,
        openMinute,
        closeHour,
        closeMinute,
        closedAllDay,
      } = this.currentDayAvailability;
      const { utcOffset } = this.channelConfig;

      if (closedAllDay) return false;

      const startTime = buildDateFromTime(openHour, openMinute, utcOffset);
      const endTime = buildDateFromTime(closeHour, closeMinute, utcOffset);
      const now = new Date();

      const isBetween =
        compareAsc(now, startTime) !== -1 &&
        compareAsc(endTime, now) !== -1;

      devLogger("isInBetweenTheWorkingHours", { currentDayAvailability: this.currentDayAvailability, utcOffset, startTime, now, endTime, isBetween });

      if (isBetween) return true;
      return false;
    },
    currentDayAvailability() {
      const { utcOffset } = this.channelConfig;
      const dayOfTheWeek = getTimezoneDate(utcOffset).getDay();
      devLogger("currentDayAvailability", { dayOfTheWeek });
      const [workingHourConfig = {}] = this.channelConfig.workingHours.filter(
        workingHour => workingHour.day_of_week === dayOfTheWeek
      );
      return {
        closedAllDay: workingHourConfig.closed_all_day,
        openHour: workingHourConfig.open_hour,
        openMinute: workingHourConfig.open_minutes,
        closeHour: workingHourConfig.close_hour,
        closeMinute: workingHourConfig.close_minutes,
      };
    },
    isInBusinessHours() {
        const { workingHoursEnabled } = this.webChannelConfig;
        return workingHoursEnabled ? this.isInBetweenTheWorkingHours : true;
      },
    isChatAvailable() {
        const { workingHoursEnabled } = this.webChannelConfig;
        const anyAgentOnline = this.onlineAgents.length > 0;
  
        return (!workingHoursEnabled && anyAgentOnline) || (workingHoursEnabled && this.isInBetweenTheWorkingHours && anyAgentOnline);
    },
  },
};
